export function useUmbrellaFreeTrialService() {
  /**
   * Returns Umbrella and its component details.
   * @param code -
   * @returns Promise<Umbrella>
   */
  const getUmbrella = async (bundleCode: string) => {
    return await $fetch('/apigateway/freeTrialResource/' + bundleCode);
  };
  return {
    getUmbrella
  };
}
